import TransactionalModal from '@berlitzplatforms/micro.modal.transactional'
import useFormattedMessage from '@hooks/useFormattedMessage'
import React from 'react'
import { TRANSLATIONS } from './constants'
import { ModalLoadingWrapper } from './style'

export interface IModalErrorContent {
  title?: string
  description?: string
  onClose: () => void
}

const ModalErrorContent: React.FC<IModalErrorContent> = ({ title, description, onClose = () => {} }) => {
  const translations = {
    API_ERROR: useFormattedMessage(title || TRANSLATIONS.API_ERROR),
    API_ERROR_DESC: useFormattedMessage(description || TRANSLATIONS.API_ERROR_DESC),
  }

  return (
    <ModalLoadingWrapper isNotification withDesc>
      <TransactionalModal
        status="warning"
        title={translations.API_ERROR}
        description={translations.API_ERROR_DESC}
        onClose={onClose}
      />
    </ModalLoadingWrapper>
  )
}

export default ModalErrorContent
